export default function Account() {
    const name = "account";
    const typeCode = 1;
    const fields = {
        "name":"name",
        "accountid":"accountid",
    }
    return{name, typeCode, fields}
}